module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ad-94e810253dbc84702e9a1b1f44e3de36.svg";